<template>
  <div>
    <data-table :service="CreditService"
                operations="add"
                :entity="entity"
                :columns="columns"
                :filters="filters"
                service-method="getCreditLogs"
                :service-path="servicePath"
                :disable-permission-checks="true"
                :go-to-details-on-row-click="false"
                :go-to-add-on-click="false"
                @on-row-click="onRowClick"
                @on-add="addClientCredit"
                ref="table">
      <template v-slot:created_at="{row}">
        {{$formatDate(row.created_at, FRIENDLY_DATETIME_FORMAT)}}
      </template>
      <template v-slot:valid_till="{row}">
        {{$formatDate(row.valid_till, FRIENDLY_DATETIME_FORMAT) || $t('generic.na')}}
      </template>
      <template v-slot:credits="{row}">
        <span class="font-weight-bold" :class="{'text-danger': row.amount < 0, 'text-success': row.amount >= 0}">{{row.amount}}</span>
      </template>
    </data-table>

    <add-credits-modal v-if="showAddModal && client"
                       :show.sync="showAddModal"
                       :client="client"
                       @submit="addCredits">
    </add-credits-modal>

    <modal :show.sync="showEditModal" v-if="showEditModal && client">
      <div slot="header"><h6>{{$t('credit.editCredit')}} {{client.name}}</h6></div>
      <form @submit.prevent="editClientCredits">
        <div class="row">
          <div class="col-12">
            <fg-input :placeholder="$t('client.management.credit.validTill')"
                      :name="$t('client.management.credit.validTill')"
                      :label="$t('client.management.credit.validTill')"
                      :picker-options="pickerOptions"
                      component="el-date-picker"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      v-model="editModel.valid_till">
              <small slot="infoBlock">
                <i class="fas fa-info-circle text-muted"></i>&nbsp;
                <span v-html="$t('credit.validDateInfo', {total: editModel.amount })"></span>
              </small>
            </fg-input>
          </div>
          <div class="col-6">
            <submit-button native-type="submit"/>
          </div>
        </div>

      </form>
    </modal>
  </div>
</template>
<script>
  import Vue from 'vue'
  import { DatePicker } from 'element-ui'
  import { mapState } from 'vuex'
  import CreditService from 'src/services/CreditService'
  import AddCreditsModal from './AddCreditsModal'
  import entities from 'src/config/entities'
  import { FRIENDLY_DATETIME_FORMAT } from 'src/config/dateUtils'
  Vue.use(DatePicker)

  export default {
    name: 'client-management-credits',
    components: {
      AddCreditsModal
    },
    data () {
      return {
        CreditService,
        entity: entities.CREDIT,
        FRIENDLY_DATETIME_FORMAT,
        showAddModal: false,
        showEditModal: false,
        editModel: {
          id: null,
          client_id: this.$route.params.id,
          valid_till: null,
          amount: 0
        },
        pickerOptions: {}
      }
    },
    computed: {
      ...mapState({
        client: state => state.client.currentClient
      }),
      columns () {
        return [
          {
            prop: 'created_at',
            label: this.$t('generic.createdAt'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'valid_till',
            label: this.$t('credit.list.labels.validTill'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'credits',
            label: this.$t('credit.list.labels.credits'),
            minWidth: '150px',
            sortable: true
          }
        ]
      },
      servicePath () {
        return `/transactions`
      },
      filters () {
        return [
          {
            key: 'sort',
            value: '+created_at'
          },
          {
            key: 'match[client_uuid]',
            value: this.$route.params.id
          }
        ]
      }
    },
    methods: {
      getError (name) {
        return this.errors.first(name)
      },
      refreshTable () {
        this.$refs.table.refresh()
      },
      onRowClick(row) {
        this.showEditModal = true
        this.editModel.valid_till = row.valid_till
        this.editModel.id = row.id
        this.editModel.amount = row.amount
      },
      async addCredits (data) {
        await CreditService.create(data)
        this.showAddModal = false
        this.refreshTable()
      },
      addClientCredit () {
        this.showAddModal = true
      },
      async editClientCredits () {
        await CreditService.update(this.editModel.id, this.editModel)
        this.showEditModal = false
      }
    }
  }
</script>
<style>
</style>
